const constants = {
  numHours: 14,
  numDays: 7,
  startOfDay: 8,
  minCalendarHeight: '1060px',
  minCalendarWidth: '1280px',
  minHourHeight: '70px',
}
export default constants



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/constants.js